import { render, staticRenderFns } from "./IndexTuoyu.vue?vue&type=template&id=b4ef3756&scoped=true&"
import script from "./IndexTuoyu.vue?vue&type=script&lang=js&"
export * from "./IndexTuoyu.vue?vue&type=script&lang=js&"
import style0 from "./IndexTuoyu.vue?vue&type=style&index=0&id=b4ef3756&prod&lang=scss&"
import style1 from "./IndexTuoyu.vue?vue&type=style&index=1&id=b4ef3756&prod&lang=scss&scoped=true&"
import style2 from "./IndexTuoyu.vue?vue&type=style&index=2&id=b4ef3756&prod&lang=scss&"
import style3 from "./IndexTuoyu.vue?vue&type=style&index=3&id=b4ef3756&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ef3756",
  null
  
)

export default component.exports